export default __webpack_public_path__ + "19e3bb3b6e6429ea163e47e62459d7f5.png";